import { Link } from 'react-router-dom'
import { AppShell } from '../components/AppShell'
import { KpiCard } from '../components/KpiCard'
import { useFundedCycle, useFundedCycles, useScore } from '../lib/api'
import { fmtDate, fmtEur } from '../lib/format'

const STATUS_TONE: Record<string, string> = {
  paid_out: 'admin-pill admin-pill--success',
  closed:   'admin-pill',
  active:   'admin-pill admin-pill--info',
  pending:  'admin-pill admin-pill--warning',
}

export function Phase4View() {
  const cycle = useFundedCycle()
  const all = useFundedCycles()
  const score = useScore()
  const c = cycle.data

  return (
    <AppShell>
      <header className="page-header">
        <div className="page-header__title-row">
          <h1 className="page-header__title">Funded — Phase 4</h1>
          <span className="page-header__subtitle">Live profit split, cyclic settlement.</span>
        </div>
        <div className="page-header__actions">
          <Link to="/payout" className="btn btn--primary">Request payout</Link>
        </div>
      </header>

      <div className="dashboard-grid dashboard-grid--cols-4" style={{ marginBottom: 'var(--space-5)' }}>
        <KpiCard label="Current balance" value={fmtEur(c?.currentBalance)} />
        <KpiCard
          label="Cycle P&L"
          value={fmtEur(c?.pnl)}
          tone={Number(c?.pnl ?? 0) >= 0 ? 'profit' : 'risk'}
        />
        <KpiCard label="Expected payout" value={fmtEur(c?.expectedPayout)} />
        <KpiCard
          label="Trader Score"
          value={score.data ? score.data.composite.toFixed(1) : '—'}
          meta={score.data ? `Updated ${fmtDate(score.data.updatedAt)}` : undefined}
        />
      </div>

      <section style={{ background: 'var(--bg-surface)', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-md)', padding: 'var(--space-5)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 'var(--space-4)' }}>
          <h3 style={{ margin: 0, fontSize: 'var(--text-md)', fontWeight: 'var(--weight-semibold)' }}>Cycle history</h3>
          <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>
            {all.data?.length ?? 0} cycle{(all.data?.length ?? 0) === 1 ? '' : 's'}
          </span>
        </div>
        <div className="admin-table">
          <table>
            <thead>
              <tr>
                <th>Cycle</th>
                <th>Started</th>
                <th>Closing balance</th>
                <th>P&L</th>
                <th>Status</th>
                <th>Payout</th>
              </tr>
            </thead>
            <tbody>
              {(all.data ?? []).map((row) => (
                <tr key={row.id}>
                  <td style={{ fontWeight: 600 }}>#{row.cycleNumber}</td>
                  <td>{fmtDate(row.startedAt)}</td>
                  <td>{fmtEur(row.currentBalance)}</td>
                  <td style={{ fontWeight: 600, color: Number(row.pnl) >= 0 ? 'var(--color-success-text)' : 'var(--admin-accent-text)' }}>
                    {fmtEur(row.pnl)}
                  </td>
                  <td><span className={STATUS_TONE[row.status] ?? 'admin-pill'}>{row.status}</span></td>
                  <td>{fmtEur(row.expectedPayout)}</td>
                </tr>
              ))}
              {(!all.data || all.data.length === 0) && (
                <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--text-tertiary)' }}>No cycles yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </AppShell>
  )
}
